<template>
  <el-dialog :title="title" :visible.sync="visible" width="50%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="文件名称:" prop="fileName">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.fileName"
          :disabled="disabled"
          placeholder="请输入30字以内文件名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="文件夹:" prop="folderId">
        <el-select v-model="data.folderId" placeholder="请选择" clearable style="width:100%" :disabled="disabled">
          <el-option v-for="dict in folderList" :key="dict.folderId" :label="dict.folderName" :value="dict.folderId" />
        </el-select>
      </el-form-item>
      <el-form-item label="文件:" prop="fileUrl">
        <FileUpload
          v-model="fileObjs"
          :readOnly="disabled"
          :limit="1"
          @on-change="handleFileChange"
        ></FileUpload>
      </el-form-item>
      <el-form-item label="描述:" prop="description">
        <el-input
          type="textarea"
          :maxlength="200"
          :disabled="disabled"
          v-model="data.description"
          show-word-limit
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="!disabled">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveFile, queryFolderList, fileDetail } from "@/api/saas/package";
import { mapState } from "vuex";
import FileUpload from "@/views/crm/components/fileUpload";

export default {
  name: "AddClueDialog",
  components: {
    FileUpload
  },
  props: {},
  data() {
    return {
      title: '',
      disabled: false,
      visible: false,
      folderList: [],
      fileObjs: [],
      rules: {
        fileName: [
          { required: true, message: "请输入文件名称", trigger: "change" }
        ],
        folderId: [{ required: true, message: "请选择文件夹", trigger: "change" }],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
      data: {
        fileName: null,
        folderName: null,
        description: null,
        fileSize: null,
        fileType: '',
        fileUrl: null,
        folderId: null,
        isImg: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      tenantId: state => state.user.tenantId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        // 重置formData
        this.resetFormData()
        this.queryFolderList()
      }
    }
  },
  mounted(){
    this.queryFolderList()
  },
  methods: {
    resetFormData () {
      this.data.companyId = null;
      this.resetForm("addForm");
      this.fileObjs = []
      this.data.fileId = null
      this.data.folderId = null
    },
    open(data, type) {
      this.visible = true;
      this.resetFormData()
      this.queryFolderList()
      if(data){
        this.fileDetail(data)
      }
      console.log('data', this.data)
      if(type === 'see') {
        this.disabled = true
        this.title = '查看文件'
      }else if(type === 'edit') {
        this.title = '编辑文件'
        this.disabled = false
      }else{
        this.disabled = false
        this.title = '新增文件'
      }
    },
    fileDetail(data) {
      fileDetail({
        fileId: data.fileId
      })
        .then(response => {
          this.data = response.data;
          this.fileObjs = [{
            url: this.data.fileUrl,
            isImg: this.data.isImg === 1,
            name: this.data.fileName
          }]
        })
        .catch(error => {});
    },
    handleFileChange(fileObjs) {
      if(fileObjs.length === 0) {
        this.fileObjsPic = []
        this.data.fileUrl = ''
      }else {
        this.fileObjs = fileObjs;
        this.data.fileSize = fileObjs[0].size
        this.data.fileUrl = fileObjs[0].url
        this.data.fileType = fileObjs[0].contentType
        this.data.isImg = fileObjs[0].isImg ? 1 : 0
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveFile(this.data)
            .then(response => {
              this.$emit("success");
              this.visible = false;
              loading.close();
              this.msgSuccess(this.data.fileId ? '编辑文件成功' : '新增文件成功');
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    customerChange() {
      let param = {
        customerId: this.data.customerId
      };
      this.data.contactId = null;
      queryContactByCustomerId(param)
        .then(response => {
          this.contactList = response.data;
        })
        .catch(error => {});
    },
    queryFolderList() {
      queryFolderList({
        tenantId: this.tenantId
      })
        .then(response => {
          this.folderList = response.rows
        })
        .catch(error => {
          loading.close();
        });
    }
  }
};
</script>
